import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

import Box from '@material-ui/core/Box'
import { BoxProps } from '@material-ui/core/Box'

import clsx from 'clsx'

type StyleProps = {
    spacing: number
}

const useStyles = makeStyles(theme => ({
    row: {
        alignItems: 'center',
        '& > *:not(:last-child)': {
            marginRight: ({ spacing }: StyleProps) => theme.spacing(spacing)
        }
    },
    column: {
        alignItems: 'flex-start',
        '& > *': {
            width: '100%'
        },
        '& > *:not(:first-child)': {
            marginTop: ({ spacing }: StyleProps) => theme.spacing(spacing)
        }
    }
}))

export type SpacedGroupProps = {
    /**
     * space between children
     */
    spacing?: number
    /**
     * direction
     */
    flexDirection?: 'row' | 'column'
    /**
     * elements inside the component
     */
    children: React.ReactNode
    /**
     * extra classes from material-ui
     */
    className?: HTMLElement['className']
    /**
     * css style rules
     */
    style?: HTMLElement['style']
} & Omit<BoxProps, 'flexDirection'>

export const SpacedGroup = ({
    children,
    className,
    style,
    spacing = 2,
    flexDirection = 'row',
    ...rest
}: SpacedGroupProps) => {
    const classes = useStyles({ spacing })

    return (
        <Box
            display="flex"
            flexDirection={flexDirection}
            className={clsx(className && className, classes[flexDirection])}
            style={style}
            {...rest}
        >
            {children}
        </Box>
    )
}
